function TwoSidedView(props) {
    const left = props.left ?? (Array.isArray(props.children) ? props.children[0] : null);
    const right = props.right ?? (Array.isArray(props.children) ? props.children[1] : null);

    return (
        <div className="w-full flex flex-col md:flex-row">
            <div className="w-full md:w-1/2">
                {left}
            </div>
            <div className="w-full md:w-1/2">
                {right}
            </div>
        </div>
    );
}

export default TwoSidedView;
